import script from "./CakeCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./CakeCarousel.vue?vue&type=script&setup=true&lang=js"

import "./CakeCarousel.vue?vue&type=style&index=0&id=417c3627&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-417c3627"]])

export default __exports__